module.exports = __webpack_public_path__ + "img/game-card-title.badea71.webp";